/*---------------------------------------------------------------------------------------------
* Copyright (c) Bentley Systems, Incorporated. All rights reserved.
* See LICENSE.md in the project root for license terms and full copyright notice.
*--------------------------------------------------------------------------------------------*/
import { useAppInsightsContext } from "@microsoft/applicationinsights-react-js";
import { useEffect } from "react";
import { useTimer } from "./useTimer";

export const useComponentEngagement = (componentName: string) => {
  const appInsights = useAppInsightsContext();
  const timer = useTimer();

  useEffect(() => {
    timer.start();
    return () => {
      const engagementTime = timer.end();
      const metricData = {
        average: Math.floor(engagementTime / 1000),
        name: "React Component Engaged Time (seconds)",
        sampleCount: 1,
      };
      const additionalProperties = { "Component Name": componentName };
      appInsights.trackMetric(metricData, additionalProperties);
    };
  }, [appInsights, componentName, timer]);
};
